import type { GridUserSettings } from '@awork/framework/state/settings.types'

export interface UserPageSettings extends GridUserSettings<UserColumn> {
  selectedDraftId?: string
}

export type UserStatuses = 'active' | 'deactivated' | 'invited'

export interface UserFilterOptions {
  onlyActive?: boolean
  includeExternal?: boolean
  usersToFilter?: string[]
}

export interface DateRangeFilter {
  startDate: Date
  endDate: Date
}

export interface UserRoleMapping {
  isDeactivated: boolean
  userId: string
  roleId: string
  name: string
}

export enum UserColumn {
  Name = 'name',
  Teams = 'teams',
  Tags = 'tags',
  Email = 'email',
  Status = 'status',
  Capacity = 'capacity',
  Role = 'role',
  Position = 'position',
  AiPlan = 'aiPlan',
  License = 'license',
  /**
   * Legacy project management access column identifier.
   * @deprecated Use License. Kept for persisted settings and migration compatibility.
   */
  PmAccess = 'pmAccess',
  AiCredits = 'aiCredits'
}

export const defaultUserPageSettings: UserPageSettings = {
  sortBy: { value: UserColumn.Name, orderBy: 'asc' },
  gridColumnSettings: [
    {
      id: UserColumn.Name,
      width: 300,
      visible: true
    },
    {
      id: UserColumn.Teams,
      width: 160,
      visible: false
    },
    {
      id: UserColumn.Tags,
      width: 160,
      visible: false
    },
    {
      id: UserColumn.Email,
      width: 240,
      visible: true
    },
    {
      id: UserColumn.Position,
      width: 160,
      visible: false
    },
    {
      id: UserColumn.Role,
      width: 160,
      visible: true
    },
    {
      id: UserColumn.Capacity,
      width: 100,
      visible: true
    },
    {
      id: UserColumn.Status,
      width: 120,
      visible: true
    },
    {
      id: UserColumn.License,
      width: 180,
      visible: true
    },
    {
      id: UserColumn.AiPlan,
      width: 200,
      visible: true
    },
    {
      id: UserColumn.AiCredits,
      width: 148,
      visible: true
    }
  ]
}

export const defaultaworkAIUserPageSettings: UserPageSettings = {
  ...defaultUserPageSettings,
  gridColumnSettings: defaultUserPageSettings.gridColumnSettings.filter(column => column.id !== UserColumn.Capacity)
}
